import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useMediaQuery from '@mui/material/useMediaQuery';
import { forgotPassword } from '../../../utils/api';
import { createNotification } from '../../../utils/alerts';
import { getErrorMessage } from '../../../utils/errorUtils';
import AdminAuthLayout from '../../../components/admin/AdminAuthLayout';
import '../admin-auth.scss';

const textFieldSx = {
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': { borderColor: '#434851' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#434851' },
};

export default function AdminForgotPasswordPage() {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await forgotPassword({ email });
            createNotification('success', 'E-mail de recuperação enviado com sucesso!', isMobile);
            navigate('/admin/login');
        } catch (err) {
            createNotification('error', getErrorMessage(err, 'Erro ao solicitar recuperação de senha.'), isMobile);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminAuthLayout title="Recuperar Senha">
            <Box component="form" onSubmit={handleSubmit} className="admin-auth-form">
                <TextField
                    fullWidth
                    label="E-mail"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                    className="admin-auth-submit-btn"
                >
                    {loading ? <CircularProgress size={22} color="inherit" /> : 'Recuperar senha'}
                </Button>
                <Button
                    variant="text"
                    fullWidth
                    onClick={() => navigate('/admin/login')}
                    className="admin-auth-link-btn"
                >
                    Voltar para o login
                </Button>
            </Box>
            <ToastContainer />
        </AdminAuthLayout>
    );
}
